import { mapSearchParamsToObject } from './utils';

/**
 * Utility for parsing the search query of a URL into an object.
 * */
export function parseQuery(queryString: string) {
  return mapSearchParamsToObject(new URLSearchParams(queryString));
}
